// extracted by mini-css-extract-plugin
module.exports = {"flex-wrapper":"Toolbox_flex-wrapper__34E5N","toolbox":"Toolbox_toolbox__qTLC-"};